// extracted by mini-css-extract-plugin
export default {"scrollHorizontal":"ScrollHorizontal_scrollHorizontal__onS65","continueBtn":"ScrollHorizontal_continueBtn__DSBuK"};